import cameraImage from '../../assets/images/setupProfileCamera.png'
import cameraImage2x from '../../assets/images/setupProfileCamera@2x.png'

interface InstantCameraIconProps {
  size?: number
  className?: string
}

/**
 * Sofortbildkamera über dem Profil-Schritt im Setup (25.09.2026, statt des
 * Notizbuchs) — es geht um Name und Bild. Dekorativ, `alt` bleibt leer.
 */
export const InstantCameraIcon = ({ size = 100, className = '' }: InstantCameraIconProps) => (
  <img
    src={cameraImage}
    srcSet={`${cameraImage} 1x, ${cameraImage2x} 2x`}
    alt=""
    width={size}
    height={size}
    className={className}
  />
)
